export default __webpack_public_path__ + "static/media/gambit.bff0af44.png";